<input type="file" class="hidden-file-input" accept="image/png, image/jpeg" onclick="this.value = null"
(change)="onFileSelected($event)" #fileUpload required>

<ng-container *ngIf="!editingBook">
    <h2>{{selectedBook?.title}}</h2>
    <p><label class="fixed-size">Title</label> <strong>{{selectedBook?.title}}</strong></p>
    <p><label class="fixed-size">Author:</label> <label class="indent"><strong>{{selectedBook?.author}}</strong></label></p>
    <p><label class="fixed-size">Purchase Link:</label> <label class="indent"><strong>{{selectedBook?.purchaseLink}}</strong></label></p>
    <p><label class="fixed-size">Summary:</label> <strong>{{selectedBook?.summary}}</strong></p>
    

    <button class="primary-button" type="add" (click)="this.editBook()">Edit Book</button>
</ng-container>
<ng-container *ngIf="editingBook">
    <h2>Editing:  {{selectedBook?.title}}<button class="delete-button" type="delete" (click)="this.removeBook()">Delete Book</button></h2>
    <br>
    <form [formGroup]="bookForm">
        <label class="fixed-size" for="title">Title: </label>
        <input id="title" type="text" formControlName="title">
        <br>
        <label class="fixed-size" for="author">Author: </label>
      <input id="author" type="text" formControlName="author" class="typeahead"
            [ngbTypeahead]="searchAuthors" />
        <br>
        <label class="fixed-size" for="purchase-link">Purchase Link: </label>
      <input id="purchase-link" type="text" formControlName="purchaseLink">
      <br>
        <div *ngIf="newFile != undefined; else noFile">
          <label class="fixed-size" for="book-image">Book Image: </label>
          <label>{{newFileName}}</label><button class="remove-button" (click)="removeFile()">x</button>
        </div>
        <ng-template #noFile>
          <label  for="book-image">Replace Book Image: </label>
          <button class="add-button" (click)="fileUpload.click()">New Image</button>
        </ng-template>
        <br>
        <label for="summary">Summary: </label><br>
        <textarea class="text-area-90" style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="10" cols="40"
          formControlName="summary"></textarea>
        <br>
      </form>
      <form [formGroup]="bookForm" (ngSubmit)="submitBookEdits()"></form>
      <button class="cancel-button" type="cancel" (click)="this.cancelClicked()">Cancel</button>
      <button class="primary-button" type="submit" [disabled]="!bookForm.valid" (click)="this.submitBookEdits()">Submit</button>
</ng-container>

<app-book-testimonials *ngIf="selectedBook?.uid" [bookUid]="selectedBook!.uid!"></app-book-testimonials>